/* BQA river template v1.3: suggested flies only. Never modifies the saved report. */
(function () {
  'use strict';
  var selector = '[data-bqa-river-flies]';
  var serial = 0;
  function string(value) { return value == null ? '' : String(value); }
  function trim(value) { return string(value).trim(); }
  function field(row, names) {
    var normalized = {};
    Object.keys(row || {}).forEach(function (key) {
      normalized[key.toLowerCase().replace(/[^a-z0-9]/g, '')] = row[key];
    });
    for (var i = 0; i < names.length; i++) {
      var value = normalized[names[i].toLowerCase().replace(/[^a-z0-9]/g, '')];
      if (value != null) return value;
    }
    return '';
  }
  function productPath(value) {
    try {
      var url = new URL(trim(value), window.location.origin);
      if (!/^https?:$/.test(url.protocol)) return '';
      if (!/^(bluequillangler\.com|www\.bluequillangler\.com|the-blue-quill-angler\.myshopify\.com)$/i.test(url.hostname)) return '';
      var match = url.pathname.match(/^\/products\/([a-zA-Z0-9_-]+)\/?$/);
      return match ? '/products/' + match[1] : '';
    } catch (_) { return ''; }
  }
  function parseFlies(value) {
    var root = new DOMParser().parseFromString(string(value), 'text/html');
    var seen = {};
    var flies = [];
    root.querySelectorAll('a[href]').forEach(function (link) {
      var path = productPath(link.getAttribute('href'));
      if (!path || seen[path]) return;
      seen[path] = true;
      var next = link.nextSibling;
      var adjacent = next && next.nodeType === 3 ? next.nodeValue : '';
      var size = (adjacent.match(/#\s*\d+(?:\s*[-–]\s*\d+)?/i) || [''])[0];
      flies.push({path: path, name: trim(link.textContent) || path.split('/').pop(), size: size});
    });
    return flies;
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function loadImage(card, fly) {
    fetch(fly.path + '.js', {credentials: 'same-origin'})
      .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
      .then(function (product) {
        var source = product.featured_image || (product.images && product.images[0]);
        if (source && typeof source === 'object') source = source.src;
        if (!source) return;
        var url = new URL(source, window.location.origin);
        if (!/^https?:$/.test(url.protocol)) return;
        var image = element('img', 'bqa-report-fly-image');
        image.alt = trim(product.title) || fly.name;
        image.loading = 'lazy';
        image.width = 72;
        image.height = 72;
        image.src = url.href;
        var wrap = card.querySelector('.bqa-report-fly-image-wrap');
        if (wrap) wrap.replaceChildren(image);
      })
      .catch(function () { /* Keep the product link and placeholder available. */ });
  }
  function render(box, row) {
    var separate = field(row, ['suggested_flies', 'suggestedFlies']);
    var flies = parseFlies(separate || field(row, ['tips']));
    // If the service has no usable links, retain the server-rendered fallback.
    if (!flies.length) return;
    var target = box.querySelector('[data-bqa-river-fly-list]');
    if (!target) return;
    var grid = element('div', 'bqa-report-fly-grid');
    flies.forEach(function (fly) {
      var card = element('a', 'bqa-report-fly-card');
      card.href = fly.path;
      var wrap = element('div', 'bqa-report-fly-image-wrap');
      wrap.appendChild(element('div', 'bqa-report-fly-image-placeholder'));
      var info = element('div', 'bqa-report-fly-info');
      info.appendChild(element('div', 'bqa-report-fly-name', fly.name));
      if (fly.size) info.appendChild(element('div', 'bqa-report-fly-size', fly.size));
      info.appendChild(element('div', 'bqa-report-fly-shop', 'Shop Fly'));
      card.append(wrap, info);
      grid.appendChild(card);
      loadImage(card, fly);
    });
    target.replaceChildren(grid);
    box.dataset.selectionLoaded = 'true';
  }
  function loadGroup(endpoint, boxes) {
    var url;
    try {
      url = new URL(endpoint);
      if (url.protocol !== 'https:' || url.hostname !== 'script.google.com' || !/^\/macros\/s\/[a-zA-Z0-9_-]+\/exec$/.test(url.pathname)) return;
    } catch (_) { return; }
    var name = 'bqaRiverFliesLoaded_' + Date.now() + '_' + (++serial);
    var script = document.createElement('script');
    var timer;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      script.remove();
      // Late JSONP responses should be harmless, without replacing other callbacks.
      window[name] = function () {};
      setTimeout(function () { delete window[name]; }, 60000);
    }
    window[name] = function (response) {
      if (done) return;
      try {
        if (!response || response.success !== true || !Array.isArray(response.rows)) return;
        boxes.forEach(function (box) {
          var slug = trim(box.dataset.riverSlug).toLowerCase();
          var row = response.rows.find(function (candidate) {
            return trim(field(candidate, ['river_slug'])).toLowerCase() === slug;
          });
          if (row) render(box, row);
        });
      } finally { finish(); }
    };
    url.searchParams.set('callback', name);
    url.searchParams.set('cache', Date.now());
    script.src = url.href;
    script.async = true;
    script.onerror = finish;
    timer = setTimeout(finish, 10000);
    document.head.appendChild(script);
  }
  function init(root) {
    var groups = {};
    (root || document).querySelectorAll(selector).forEach(function (box) {
      if (box.dataset.flyRequestStarted === 'true') return;
      box.dataset.flyRequestStarted = 'true';
      var endpoint = trim(box.dataset.endpoint);
      if (!endpoint) return;
      (groups[endpoint] || (groups[endpoint] = [])).push(box);
    });
    Object.keys(groups).forEach(function (endpoint) { loadGroup(endpoint, groups[endpoint]); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  // Support theme editor section reloads without depending on app callbacks.
  if (!window.bqaRiverFliesEditorListener) {
    window.bqaRiverFliesEditorListener = true;
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
})();
